module.exports = __webpack_public_path__ + "img/dr-dan-kjeldgaard-advanced-chirocare.ace5de38.jpg";